import { useWeb3React } from '@web3-react/core'
import ConnectWalletButton from 'components/ConnectWalletButton'
import LanguageSelector from 'components/LanguageSelector'
import { useTranslation } from 'contexts/Localization'
import useIsMobile from 'hooks/useIsMobile'
import { useRouter } from 'next/router'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Box, Flex, Link } from 'widgets'
import CutAvatar from 'widgets/Svg/Icons/CutAvatar'
import CollapseIcon from './CollapseIcon'
import MenuAccount from './MenuAccount'
import MenuCart from './MenuCart'
import MenuNoti from './MenuNoti'
import MenuSearchExchange from './MenuSearchExchange'
import MenuText from './MenuText'
import MenuWallet from './MenuWallet'
import MobileSlider from './MobileSlider'
import MobileWallet from './MobileWallet'
import RedirectProfile from './RedirectProfile'
import SearchBar from './SearchBar'
import { MenuEntry } from './types'

const WrapperHeader = styled.header<{ background: string; isMobile: boolean }>`
  max-width: 100vw;
  position: fixed;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 75px;
  transition: 0.25s;
  z-index: 999;

  background: ${({ background }) => background};

  box-shadow: ${({ background, isMobile }) =>
    isMobile || background === 'transparent' ? `none` : `rgba(100, 100, 111, 0.2) 0px 7px 29px 0px`};

  .content {
    position: relative;
    max-width: 1300px;
    padding: 0 14px;
    margin: 0 auto;
    width: 100%;

    display: flex;
    justify-content: space-between;

    .menu-left {
      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        width: 89px;
        min-width: 89px;
      }
    }

    .menu-mid {
      margin-left: 60px;
      flex: 1;

      &:not(.is-scroll) {
        input {
          color: #fff !important;

          &::placeholder {
            color: #fff !important;
          }
        }
      }

      input {
        color: #000 !important;
      }
    }

    .menu-right {
      display: flex;
      align-items: center;
      margin-right: 15px;

      &.is-scroll {
        .menu-list {
          li {
            a {
              color: #000;
            }
          }
        }

        button {
          &.open-app-btn {
            background: #006dfe;
            color: #ffffff;
          }

          &#selected-country-btn {
            background: #ffffff;
            border: 1px solid #000000;
            height: 36px;

            span {
              &:after {
                color: #006dfe !important;
              }
            }

            &:hover {
              background: transparent;
              border: 1px solid #006dfe;
              color: #006dfe;

              span {
                &:after {
                  color: #006dfe !important;
                }
              }
            }
          }
        }
      }

      button {
        &.open-app-btn {
          font-style: normal;
          font-weight: 700;
          font-size: 14px;
          line-height: 18px;
          text-transform: uppercase;
          color: #006dfe;
          background-color: #fff;
          max-width: 145px;
          height: 36.33px;

          &:hover {
            background: linear-gradient(143.11deg, #006dfe 21.44%, #43e8e1 126.28%);
            color: #efefef;
          }
        }

        &#selected-country-btn {
          background: #ffffff;
          border: none;
          height: 36px;

          span {
            &:after {
              color: #000000 !important;
            }
          }

          &:hover {
            background: linear-gradient(143.11deg, #006dfe 21.44%, #43e8e1 126.28%);
            border: none;
            color: #efefef;

            span {
              &:after {
                color: #efefef !important;
              }
            }
          }
        }
      }

      .menu-list {
        width: 100%;
        display: flex;
        align-items: center;
        list-style: none;
        margin: 0 35px;

        li {
          position: relative;

          &:not(:last-child) {
            margin-right: 30px;
          }

          a {
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            color: #fff;
            display: block;
            transition: 0.2s;

            &:nth-child(2) {
              position: absolute;
              top: 0;
              left: 0;
            }

            &:hover {
              color: #006dfe;
            }
          }

          &.active a {
            font-weight: 600;
            color: #006dfe;
          }
        }
      }

      .notify-icon {
        width: 30px;
        position: relative;
        margin-right: 16px;
        cursor: pointer;

        span {
          position: absolute;
          top: 2px;
          right: -3px;
          width: 18px;
          height: 18px;
          background: #f41706;
          border-radius: 50%;

          display: flex;
          align-items: center;
          justify-content: center;
        }
        img {
          width: 100%;
        }
      }

      .menu-actions-desktop {
        position: relative;
        display: flex;
        align-items: center;

        > button {
          &:not(:last-child) {
            margin-left: 31px;
            margin-right: 13px;
          }
        }
      }

      .open-app-btn {
        min-width: 180px;
        margin-left: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 30px;
        text-transform: uppercase;
        padding: 0;
      }

      &:not(.is-scroll) {
        .menu-list {
          li {
            a {
              color: #fff;

              &:nth-child(2) {
                &:hover {
                  filter: blur(5px);
                }
              }
            }

            &.active a {
              &:nth-child(2) {
                filter: blur(5px);
              }
            }
          }
        }
      }
    }
  }

  .ant-select-dropdown {
    padding-bottom: 30px;

    &.ant-select-dropdown-placement-bottomLeft {
      background: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(5px);
      border-radius: 10px;
    }

    &:after {
      content: 'Press enter to search all item';
      position: absolute;
      padding-left: 16px;
      height: 30px;
      border-top: 1px solid rgba(109, 109, 109, 0.5);
      width: 100%;
      padding-top: 2px;
    }
  }

  .bottom-search {
    position: absolute;
    bottom: 0;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #000000;
    width: 100%;
    padding-top: 7px;
    padding-bottom: 0;
    transform: translateY(100%);
    height: 30px;
    border-top: 1px solid rgba(109, 109, 109, 0.5);
  }

  .wrap-account {
    display: flex;
    align-items: center;
    margin-left: -2px;

    .wrap-avatar {
      margin-right: 5px;
    }
  }
  @media (max-width: 1024px) {
    .isTablet {
      .menu-right {
        margin: 0 15px;
        width: 284px;
        .menu-right-mobile-items {
          display: flex;
          width: 100%;
          justify-content: space-around;
        }
      }
    }

    .content {
      .menu-right {
        margin: 0 15px;
        .menu-list {
          margin: 0;
        }
        .input-search-mobile {
          min-width: 95%;
        }
        .menu-right-mobile-items {
          gap: 18px;
          .open-app-btn {
            margin: 0;
          }
        }
        img {
          height: 26px;
          margin: auto;
          cursor: pointer;
        }

        &:not(.is-scroll) {
          img,
          .navbar-header {
            filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(328deg) brightness(103%) contrast(101%);
          }
        }
      }
    }
    .active-search {
      width: 100%;
      justify-content: space-between;
      .content {
        svg {
          right: 12px;
          left: auto;
        }
        /* .button-clear {
          margin: auto;
        } */
      }
    }
  }
  @media (max-width: 572px) {
    .menu-right {
      flex: 1;
      justify-content: end;
      .menu-right-mobile-items {
        .open-app-btn {
          height: 30.33px;
          min-width: 145px;
        }
      }
      .input-search-mobile {
        width: 100%;
        min-wit input {
          padding: 4px 8px;
        }
      }
      .icon-prev {
        padding: 16px;
      }
    }
    .content {
      svg {
        left: auto;
        cursor: pointer;
        right: 18px;
      }
      .button-clear {
        width: 30px;
        margin: auto;
      }
    }
    .edit-cover-bg {
      position: fixed;
      bottom: 0;
      z-index: 1000;
      width: 100%;
      display: flex;
      flex-direction: column;
      background: white;
      padding: 56px 0;
      gap: 12px;
      .action-cover {
        width: 390px;
        height: 36px;
        background: #e9e9e9;
        border-radius: 5px;
        width: 90%;
        color: #000000;
        border: none;
        margin: 0 auto;
        font-size: 16px;
        font-weight: 700;
      }
      .save-cover {
        background: #006dfe;
        color: #fff;
      }
      .action-cover:hover {
        opacity: 0.8;
      }
    }
  }
  .mobile-navbar-menu {
    max-width: 100vw;
    position: fixed;
    height: 72px;
    color: black;
    bottom: 0;
    display: flex;
    width: 100%;
    font-size: 9px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    justify-content: space-evenly;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

    > a {
      display: block;
      width: 100%;
      background: url('/images/footer/bg-mobile-none.png');
      background-position: center;

      &.active {
        background: url('/images/footer/bg-mobile.png');
        background-position: 49.6% center;
      }
    }

    .navbar-item {
      height: 100%;
      font-weight: bold;
      display: flex;
      justify-content: end;
      position: relative;
      flex-direction: column;
      cursor: pointer;
      p {
        margin-bottom: 16px;
        text-align: center;
      }
      .border-icon {
        border-radius: 50%;
        position: absolute;
        top: 36%;
        left: 50%;
        transform: translate(-50%, -50%);

        .active {
          display: none;
        }
        img {
          margin: auto;
          position: relative;
          display: block;
          width: 24px;
          height: 24px;
        }
      }
    }

    ${({ theme }) => theme.mediaQueries.lg} {
      .navbar-item:hover {
        position: relative;
        .border-icon {
          width: 55px;
          height: 55px;
          top: 6px;
          background: linear-gradient(143deg, #006dfe 21.44%, #43e8e1 126.28%);
          transition: 0.5s;
          display: flex;
          .active {
            display: block;
          }
          .default {
            display: none;
          }
          img {
            margin: auto;
            position: relative;
            display: block;
            width: 24px;
            height: 24px;
            transition: 0.2s;
          }
        }
        .border-icon::after {
          content: '';
          position: absolute;
          top: 59%;
          right: -8px;
          background: transparent;
          width: 6px;
          height: 6px;
          border-top-left-radius: 5px;
          /* box-shadow: 0 -2px 0 0 #006dfe; */
        }
        .border-icon::before {
          content: '';
          position: absolute;
          top: 59%;
          left: -9px;
          background: transparent;
          width: 6px;
          height: 6px;
          border-top-right-radius: 5px;
          /* box-shadow: 0 -2px 0 0 #006dfe; */
        }
      }
    }
    .active {
      position: relative;
      .border-icon {
        width: 55px;
        height: 55px;
        top: 6px;
        background: linear-gradient(143deg, #006dfe 21.44%, #43e8e1 126.28%);
        transition: 0.5s;
        display: flex;
        .active {
          display: block;
        }
        .default {
          display: none;
        }
        img {
          margin: auto;
          position: relative;
          display: block;
          width: 24px;
          height: 24px;
          transition: 0.2s;
        }
      }
      .border-icon::after {
        content: '';
        position: absolute;
        top: 59%;
        right: -8px;
        background: transparent;
        width: 6px;
        height: 6px;
        border-top-left-radius: 5px;
        /* box-shadow: 0 -2px 0 0 #006dfe; */
      }
      .border-icon::before {
        content: '';
        position: absolute;
        top: 59%;
        left: -9px;
        background: transparent;
        width: 6px;
        height: 6px;
        border-top-right-radius: 5px;
        /* box-shadow: 0 -2px 0 0 #006dfe; */
      }
    }
  }
`

interface Props {
  menuItems: MenuEntry[]
  hasSider?: boolean
  isLogin: boolean
}

const mobileWith = 572
const tableWith = 1024

const Header: React.FC<Props> = ({ menuItems, hasSider = false, isLogin }) => {
  const router = useRouter()
  const routerAsPath = router.asPath
  const { t } = useTranslation()
  const { userInfo } = useSelector((state: any) => state.user)
  const collectionItems = [
    {
      ...menuItems[1],
      label: <img src="/images/header/icon-add.svg" alt="icon-add" />,
    },
  ]

  const [isScroll, updateIsScroll] = useState(false)
  const [showSlider, setShowSlider] = useState(false)
  const [boxShadow, setBoxShadow] = useState(false)
  const [isOpenSearch, setIsOpenSearch] = useState(false)
  const isMobile = useIsMobile(mobileWith)
  const isTablet = useIsMobile(tableWith)
  const { account } = useWeb3React()

  const refContainerDropdown = useRef(null)
  const toggleMenu = () => {
    setShowSlider((prev) => !prev)
  }

  useEffect(() => {
    setShowSlider(false)
  }, [routerAsPath])

  const changeBackground = useCallback(() => {
    if (window.scrollY >= 30 || (router.pathname !== '/' && router.pathname !== '/nft/detail/[slug]')) {
      updateIsScroll(true)
    } else {
      updateIsScroll(false)
    }

    if (window.scrollY >= 30) {
      setBoxShadow(true)
    } else {
      setBoxShadow(false)
    }
  }, [router.pathname])

  useEffect(() => {
    changeBackground()
    // adding the event when scroll change background
    window.addEventListener('scroll', changeBackground)
  }, [changeBackground])

  const renderMenuRight = () => {
    if (isTablet) {
      if (!isOpenSearch) {
        if (
          routerAsPath === '/wallet' ||
          routerAsPath === '/notification' ||
          routerAsPath === '/profile' ||
          routerAsPath === '/settings'
        ) {
          return (
            <Flex className="menu-right-mobile-items">
              {!showSlider && (
                <Flex>
                  <img
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                    role="button"
                    tabIndex={0}
                    src="/images/header/icon-search.svg"
                    alt="icon-search"
                    onClick={() => setIsOpenSearch(!isOpenSearch)}
                    aria-hidden="true"
                  />
                </Flex>
              )}
            </Flex>
          )
        }
        return (
          <Flex className="menu-right-mobile-items">
            {!showSlider && (
              <Flex>
                <img
                  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                  role="button"
                  tabIndex={0}
                  src="/images/header/icon-search.svg"
                  alt="icon-search"
                  onClick={() => setIsOpenSearch(!isOpenSearch)}
                  aria-hidden="true"
                />
              </Flex>
            )}
            {!showSlider &&
              (account && isLogin ? (
                <>
                  <MenuText refContainerDropdown={refContainerDropdown} menuItems={collectionItems} />
                  <MenuCart refContainerDropdown={refContainerDropdown} isScroll={isScroll} />
                </>
              ) : (
                <ConnectWalletButton className="open-app-btn" />
              ))}

            <CollapseIcon active={showSlider} toggleMenu={toggleMenu} isMobile={isMobile} />
          </Flex>
        )
      }
      return (
        <>
          <div className="icon-prev">
            <img
              // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
              role="button"
              tabIndex={0}
              src="/images/header/icon-prev.svg"
              alt="icon-prev"
              onClick={() => setIsOpenSearch(!isOpenSearch)}
              aria-hidden="true"
            />
          </div>
          <SearchBar refContainerDropdown={refContainerDropdown} isScroll={isScroll} isMobile={isMobile} />
        </>
      )
    }
    if (isTablet) {
      return (
        <Flex className="menu-right-mobile-items isTablet">
          {!showSlider &&
            (account && isLogin ? (
              <>
                <MenuText refContainerDropdown={refContainerDropdown} menuItems={collectionItems} />
                <MenuCart refContainerDropdown={refContainerDropdown} isScroll={isScroll} />
              </>
            ) : (
              <ConnectWalletButton className="open-app-btn" />
            ))}

          <CollapseIcon active={showSlider} toggleMenu={toggleMenu} isMobile={isTablet} />
        </Flex>
      )
    }
    return (
      <div className="menu-actions-desktop">
        <MenuText refContainerDropdown={refContainerDropdown} menuItems={menuItems} />

        {/* <MenuSearchExchange isScroll={isScroll} /> */}

        {account && isLogin && <MenuWallet refContainerDropdown={refContainerDropdown} isScroll={isScroll} />}

        {account && isLogin && <MenuCart refContainerDropdown={refContainerDropdown} isScroll={isScroll} />}

        {account && isLogin && <MenuNoti refContainerDropdown={refContainerDropdown} isScroll={isScroll} />}

        {account && isLogin ? (
          <MenuAccount refContainerDropdown={refContainerDropdown} userInfo={userInfo} />
        ) : (
          <ConnectWalletButton className="open-app-btn" />
        )}
        <LanguageSelector style={{ marginRight: '10px' }} />
      </div>
    )
  }

  return (
    <>
      <WrapperHeader
        background={
          routerAsPath === '/notification' || routerAsPath === '/profile'
            ? '#f8f8f8'
            : !isScroll
            ? 'transparent'
            : '#fff'
        }
        isMobile={isMobile}
        style={{ boxShadow: !boxShadow && 'none' }}
        ref={refContainerDropdown}
      >
        <div className="content">
          {!hasSider && !isOpenSearch ? (
            <div className="menu-left">
              {routerAsPath === '/settings' && isTablet ? (
                <h3 style={{ fontSize: ' 24px', fontWeight: 'bold' }}>Settings</h3>
              ) : routerAsPath === '/profile' && isTablet ? (
                <h3 style={{ fontSize: ' 24px', fontWeight: 'bold' }}>Profile</h3>
              ) : routerAsPath === '/wallet' && isTablet ? (
                <h3 style={{ fontSize: ' 24px', fontWeight: 'bold' }}>My Wallet</h3>
              ) : routerAsPath === '/notification' && isTablet ? (
                <h3 style={{ fontSize: ' 24px', fontWeight: 'bold' }}>Notification</h3>
              ) : (
                <Link href="/">
                  {isScroll || showSlider ? (
                    <img src="/images/logo.svg" alt="" />
                  ) : (
                    <img src="/images/white-logo.png" alt="" />
                  )}
                </Link>
              )}
            </div>
          ) : (
            <div />
          )}
          {!isMobile && (
            <div className={`menu-mid ${isScroll ? 'is-scroll' : ''}`}>
              <SearchBar refContainerDropdown={refContainerDropdown} isScroll={isScroll} />
            </div>
          )}

          <div className={`menu-right ${isOpenSearch && 'active-search'} ${isScroll || showSlider ? 'is-scroll' : ''}`}>
            {renderMenuRight()}
          </div>
        </div>
        {isTablet && (
          <div className="mobile-navbar-menu">
            <Link href="/" className={routerAsPath === '/' ? 'navbar-item active' : 'navbar-item'}>
              <div>
                <div className="border-icon">
                  <img className="default" src="/images/icons/icon-home.svg" alt="icon-home" />
                  <img className="active" src="/images/icons/icon-home-active.svg" alt="icon-home" />
                </div>
                <p>Home</p>
              </div>
            </Link>
            <Link href="/wallet" className={routerAsPath === '/wallet' ? 'navbar-item active' : 'navbar-item'}>
              <div>
                <div className="border-icon">
                  <img className="default" src="/images/icons/icon-wallet-mb.svg" alt="icon-wallet-mb" />
                  <img
                    className="active"
                    src="/images/icons/icon-wallet-active.svg"
                    alt="/images/icons/icon-wallet-active.svg"
                  />
                </div>
                <p>Wallet</p>
              </div>
            </Link>
            <Link
              href="/marketplace"
              className={routerAsPath === '/marketplace' ? 'navbar-item active' : 'navbar-item'}
            >
              <div className="navbar-item">
                <div className="border-icon">
                  <img className="default" src="/images/icons/icon-marketplace.svg" alt="icon-marketplace" />
                  <img className="active" src="/images/icons/icon-marketplace-active.svg" alt="icon-marketplace" />
                </div>
                <p>Marketplace</p>
              </div>
            </Link>
            <Link
              href="/notification"
              className={routerAsPath === '/notification' ? 'navbar-item active' : 'navbar-item'}
            >
              <div className="navbar-item">
                <div className="border-icon">
                  <img className="default" src="/images/icons/icon-nofi.svg" alt="icon-nofi" />
                  <img className="active" src="/images/icons/icon-nofi-active.svg" alt="nofi-active" />
                </div>
                <p>Notification</p>
              </div>
            </Link>

            <Link
              href="/profile"
              className={
                routerAsPath === '/account' || routerAsPath === '/profile' || routerAsPath === '/settings'
                  ? 'navbar-item active'
                  : 'navbar-item'
              }
            >
              <Box className="navbar-item" onClick={() => router.push('/profile')}>
                <div className="border-icon">
                  {account && isLogin ? (
                    <MenuAccount refContainerDropdown={refContainerDropdown} userInfo={userInfo} />
                  ) : (
                    <>
                      <img className="default" src="/images/icons/icon-profile.svg" alt="icon-profile" />
                      <img className="active" src="/images/icons/icon-profile-active.svg" alt="icon-profile-active" />
                    </>
                  )}
                </div>
                <p>Profile</p>
              </Box>
            </Link>
          </div>
        )}
      </WrapperHeader>
      {(isMobile || isTablet) && <MobileSlider visible={showSlider} links={menuItems} toggleMenu={toggleMenu} />}
      {routerAsPath === '/wallet' && <MobileWallet />}
      {routerAsPath === '/profile' && <RedirectProfile />}

      <CutAvatar className="hidden-all" />
    </>
  )
}

export default Header
